export default{
	priority:[
	{
		id: "1",
		name: "Low"
	},
	{
		id: "2",
		name: 'Medium'
	},
	{
		id: "3",
		name: "High"
	},
	{
		id: "4",
		name: "Very High"
	}
	],
	districts : [		
	{       
		id: "0",    
		zip: "",   
		province: "",    
		district: "อื่นๆ",   
		lat: 0,    
		lng: 0    
	},		
	{				
		id: "1",		
		zip: "10200",		
		province: "กรุงเทพมหานคร",		
		district: "พระนคร",		
		lat: 13.7560243,		
		lng: 100.4986793		
	},			
	{			
		id: "2",		
		zip: "10300",		
		province: "กรุงเทพมหานคร",		
		district: "ดุสิต",		
		lat: 13.7726943,		
		lng: 100.5099262		
	},			
	{			
		id: "3",		
		zip: "10530",		
		province: "กรุงเทพมหานคร",		
		district: "หนองจอก",		
		lat: 13.8559883,		
		lng: 100.8619689		
	},			
	{			
		id: "4",		
		zip: "10500",		
		province: "กรุงเทพมหานคร",		
		district: "บางรัก",		
		lat: 13.7262395,		
		lng: 100.5267991		
	},			
	{			
		id: "5",		
		zip: "10220",		
		province: "กรุงเทพมหานคร",		
		district: "บางเขน",		
		lat: 13.864387,		
		lng: 100.6146434		
	},			
	{			
		id: "6",		
		zip: "10240",		
		province: "กรุงเทพมหานคร",		
		district: "บางกะปิ",		
		lat: 13.7650282,		
		lng: 100.6473885		
	},			
	{			
		id: "7",		
		zip: "10330",		
		province: "กรุงเทพมหานคร",		
		district: "ปทุมวัน",		
		lat: 13.7401666,		
		lng: 100.5352367		
	},			
	{			
		id: "8",		
		zip: "10100",		
		province: "กรุงเทพมหานคร",		
		district: "ป้อมปราบศัตรูพ่าย",		
		lat: 13.7514954,		
		lng: 100.5108479		
	},			
	{			
		id: "9",		
		zip: "10260",		
		province: "กรุงเทพมหานคร",		
		district: "พระโขนง",		
		lat: 13.6910654,		
		lng: 100.614025		
	},			
	{			
		id: "10",		
		zip: "10510",		
		province: "กรุงเทพมหานคร",		
		district: "มีนบุรี",		
		lat: 13.8130488,		
		lng: 100.731339		
	},			
	{			
		id: "11",		
		zip: "10520",		
		province: "กรุงเทพมหานคร",		
		district: "ลาดกระบัง",		
		lat: 13.7277339,		
		lng: 100.7486314		
	},			
	{			
		id: "12",		
		zip: "10120",		
		province: "กรุงเทพมหานคร",		
		district: "ยานนาวา",		
		lat: 13.7171256,		
		lng: 100.5151327		
	},			
	{			
		id: "13",		
		zip: "10100",		
		province: "กรุงเทพมหานคร",		
		district: "สัมพันธวงศ์",		
		lat: 13.7380091,		
		lng: 100.5098502		
	},			
	{			
		id: "14",		
		zip: "10400",		
		province: "กรุงเทพมหานคร",		
		district: "พญาไท",		
		lat: 13.7568078,		
		lng: 100.5337793		
	},			
	{			
		id: "15",		
		zip: "10600",		
		province: "กรุงเทพมหานคร",		
		district: "ธนบุรี",		
		lat: 13.7164911,		
		lng: 100.4874338		
	},			
	{			
		id: "16",		
		zip: "10600",		
		province: "กรุงเทพมหานคร",		
		district: "บางกอกใหญ่",		
		lat: 13.7320727,		
		lng: 100.4814589		
	},			
	{			
		id: "17",		
		zip: "10310",		
		province: "กรุงเทพมหานคร",		
		district: "ห้วยขวาง",		
		lat: 13.7790391,		
		lng: 100.5739529		
	},			
	{			
		id: "18",		
		zip: "10600",		
		province: "กรุงเทพมหานคร",		
		district: "คลองสาน",		
		lat: 13.7279708,		
		lng: 100.5087902		
	},			
	{			
		id: "19",		
		zip: "10170",		
		province: "กรุงเทพมหานคร",		
		district: "ตลิ่งชัน",		
		lat: 13.7733179,		
		lng: 100.4284178		
	},			
	{			
		id: "20",		
		zip: "10700",		
		province: "กรุงเทพมหานคร",		
		district: "บางกอกน้อย",		
		lat: 13.7604091,		
		lng: 100.471573		
	},			
	{			
		id: "21",		
		zip: "10150",		
		province: "กรุงเทพมหานคร",		
		district: "บางขุนเทียน",		
		lat: 13.5995816,		
		lng: 100.4331316		
	},			
	{			
		id: "22",		
		zip: "10160",		
		province: "กรุงเทพมหานคร",		
		district: "ภาษีเจริญ",		
		lat: 13.7207491,		
		lng: 100.4577015		
	},			
	{			
		id: "23",		
		zip: "10160",		
		province: "กรุงเทพมหานคร",		
		district: "หนองแขม",		
		lat: 13.7207491,		
		lng: 100.4577015		
	},			
	{			
		id: "24",		
		zip: "10140",		
		province: "กรุงเทพมหานคร",		
		district: "ราษฎร์บูรณะ",		
		lat: 13.6812411,		
		lng: 100.5037003		
	},			
	{			
		id: "25",		
		zip: "10700",		
		province: "กรุงเทพมหานคร",		
		district: "บางพลัด",		
		lat: 13.7919952,		
		lng: 100.5004335		
	},			
	{			
		id: "26",		
		zip: "10400",		
		province: "กรุงเทพมหานคร",		
		district: "ดินแดง",		
		lat: 13.7630761,		
		lng: 100.5433408		
	},			
	{			
		id: "27",		
		zip: "10240",		
		province: "กรุงเทพมหานคร",		
		district: "บึงกุ่ม",		
		lat: 13.8038957,		
		lng: 100.647812		
	},			
	{			
		id: "28",		
		zip: "10120",		
		province: "กรุงเทพมหานคร",		
		district: "สาทร",		
		lat: 13.6937454,		
		lng: 100.510007		
	},			
	{			
		id: "29",		
		zip: "10800",		
		province: "กรุงเทพมหานคร",		
		district: "บางซื่อ",		
		lat: 13.803181,		
		lng: 100.5393292		
	},			
	{			
		id: "30",		
		zip: "10900",		
		province: "กรุงเทพมหานคร",		
		district: "จตุจักร",		
		lat: 13.8037421,		
		lng: 100.5546027		
	},			
	{			
		id: "31",		
		zip: "10120",		
		province: "กรุงเทพมหานคร",		
		district: "บางคอแหลม",		
		lat: 13.6954096,		
		lng: 100.5127381		
	},			
	{			
		id: "32",		
		zip: "10250",		
		province: "กรุงเทพมหานคร",		
		district: "ประเวศ",		
		lat: 13.693295,		
		lng: 100.645971		
	},			
	{			
		id: "33",		
		zip: "10110",		
		province: "กรุงเทพมหานคร",		
		district: "คลองเตย",		
		lat: 13.7225158,		
		lng: 100.5540678		
	},			
	{			
		id: "34",		
		zip: "10250",		
		province: "กรุงเทพมหานคร",		
		district: "สวนหลวง",		
		lat: 13.7194781,		
		lng: 100.6129534		
	},			
	{			
		id: "35",		
		zip: "10150",		
		province: "กรุงเทพมหานคร",		
		district: "จอมทอง",		
		lat: 13.6955177,		
		lng: 100.4453018		
	},			
	{			
		id: "36",		
		zip: "10210",		
		province: "กรุงเทพมหานคร",		
		district: "ดอนเมือง",		
		lat: 13.9245384,		
		lng: 100.6038701		
	},			
	{			
		id: "37",		
		zip: "10400",		
		province: "กรุงเทพมหานคร",		
		district: "ราชเทวี",		
		lat: 13.7516381,		
		lng: 100.5315687		
	},			
	{			
		id: "38",		
		zip: "10230",		
		province: "กรุงเทพมหานคร",		
		district: "ลาดพร้าว",		
		lat: 13.8289265,		
		lng: 100.5943624		
	},			
	{			
		id: "39",		
		zip: "10110",		
		province: "กรุงเทพมหานคร",		
		district: "วัฒนา",		
		lat: 13.7398583,		
		lng: 100.5594458		
	},			
	{			
		id: "40",		
		zip: "10160",		
		province: "กรุงเทพมหานคร",		
		district: "บางแค",		
		lat: 13.6988894,		
		lng: 100.4210604		
	},			
	{			
		id: "41",		
		zip: "10210",		
		province: "กรุงเทพมหานคร",		
		district: "หลักสี่",		
		lat: 13.8841935,		
		lng: 100.5774799		
	},			
	{			
		id: "42",		
		zip: "10220",		
		province: "กรุงเทพมหานคร",		
		district: "สายไหม",		
		lat: 13.9213159,		
		lng: 100.683202		
	},			
	{			
		id: "43",		
		zip: "10230",		
		province: "กรุงเทพมหานคร",		
		district: "คันนายาว",		
		lat: 13.793899,		
		lng: 100.692192		
	},			
	{			
		id: "44",		
		zip: "10240",		
		province: "กรุงเทพมหานคร",		
		district: "สะพานสูง",		
		lat: 13.7676357,		
		lng: 100.6928804		
	},			
	{			
		id: "45",		
		zip: "10310",		
		province: "กรุงเทพมหานคร",		
		district: "วังทองหลาง",		
		lat: 13.7802488,		
		lng: 100.5999507		
	},			
	{			
		id: "46",		
		zip: "10510",		
		province: "กรุงเทพมหานคร",		
		district: "คลองสามวา",		
		lat: 13.8381942,		
		lng: 100.7295908		
	},			
	{			
		id: "47",		
		zip: "10260",		
		province: "กรุงเทพมหานคร",		
		district: "บางนา",		
		lat: 13.6682906,		
		lng: 100.6048034		
	},			
	{			
		id: "48",		
		zip: "10170",		
		province: "กรุงเทพมหานคร",		
		district: "ทวีวัฒนา",		
		lat: 13.7648929,		
		lng: 100.3343991		
	},			
	{			
		id: "49",		
		zip: "10140",		
		province: "กรุงเทพมหานคร",		
		district: "ทุ่งครุ",		
		lat: 13.6191708,		
		lng: 100.5103542		
	},			
	{			
		id: "50",		
		zip: "10150",		
		province: "กรุงเทพมหานคร",		
		district: "บางบอน",		
		lat: 13.6670215,		
		lng: 100.4036861		
	}			
	]		
}


// WEBPACK FOOTER //
// ./src/config/reporter.js